
import Vue from 'vue';
import Component from 'vue-class-component';
import {Action, Getter, Mutation} from 'vuex-class';
import {UyapEngeli} from '@/types';
import {IProcessedTaskChilds, ITask} from '@/plugins/uyap-plugin/store/modules/GorevYoneticisiTypes';
import {TaskDurum} from '@/plugins/uyap-plugin/enum/TaskDurum';
import {TaskTuru, TaskTuruLabel} from '@/plugins/uyap-plugin/enum/TaskTuru';
import {UYAP_ENGEL_METINLERI, engelOzetMetni} from '@/utils/uyapEngeli';

/**
 * UYAP "insan doğrulaması" uyarısı (engel; DEV-3572). Görsel dil DevreKesiciDialog ile aynı; ton kritik (kırmızı).
 *
 *  - persistent: yalnız düğmelerle kapanır. "Kapat" YALNIZ pencereyi kapatır (kilit, kayıt ve bot durumuna dokunmaz;
 *    kart ve liste bandındaki "Ayrıntı" pencereyi bildirim/ses OLMADAN yeniden açar).
 *  - "Yeniden denemeye izin ver" ONAYSIZ tek eylemdir (düğmenin etiketi onaydır): kilidi kaldırır ve botu başlatır.
 *    Onay yalnız Başlat düğmesinde sorulur.
 *  - UYAP'ın nasıl kaldırılacağına dair HİÇBİR talimat yoktur (UYAP'ın uyarıyı nasıl kaldırdığı bilinmiyor).
 */
@Component({})
export default class UyapEngeliDialog extends Vue {
  @Getter uyapEngeli!: UyapEngeli | null;
  @Getter getSiradakiGorevler!: Array<ITask>;
  @Getter getChildTasksStatus!: Array<IProcessedTaskChilds>;
  @Mutation setUyapEngeliDiyalogu!: (acik: boolean) => void;
  @Action openUyapWindow!: () => void;
  @Action uyapEngeliniKaldirVeBaslat!: (payload?: { kaynak?: 'diyalog' | 'baslat' }) => Promise<boolean>;

  metinler = UYAP_ENGEL_METINLERI;
  deneniyor = false;

  get acik(): boolean {
    return !!this.uyapEngeli && this.uyapEngeli.diyalogAcik === true;
  }

  set acik(v: boolean) {
    // persistent diyalog; kapatma yalnızca düğmelerden.
    if (!v) this.kapat();
  }

  /** UYAP'ın özgün metni; sunucu freninde (kaynak 'sunucu') ya da metin boşken alıntı çizilmez. */
  get uyapMetni(): string {
    const engel = this.uyapEngeli;
    if (!engel || engel.kaynak === 'sunucu' || typeof engel.mesaj !== 'string') {
      return '';
    }
    return engel.mesaj;
  }

  /** "Takip Sorgula · 312 dosya sırada · 14:32": en iyi çaba, bilinmeyen parça atlanır (en azından saat). */
  get ozet(): string {
    const engel = this.uyapEngeli;
    if (!engel) {
      return '';
    }
    const gorevler = Array.isArray(this.getSiradakiGorevler) ? this.getSiradakiGorevler : [];
    const gorev = gorevler.find((g: ITask) => g.status == TaskDurum.DURAKLATILDI || g.status == TaskDurum.ISLENIYOR);
    const etiket = gorev ? TaskTuruLabel[(gorev.task_type_id as TaskTuru)] : undefined;
    const cocuklar = Array.isArray(this.getChildTasksStatus) ? this.getChildTasksStatus : [];
    const sirada = cocuklar.filter((c: IProcessedTaskChilds) => c.status === TaskDurum.SIRADA).length;
    return engelOzetMetni(engel.zaman, typeof etiket === 'string' ? etiket : null, sirada);
  }

  kapat() {
    this.setUyapEngeliDiyalogu(false);
  }

  uyapiAc() {
    this.openUyapWindow();
  }

  async izinVer() {
    if (this.deneniyor) return;
    this.deneniyor = true;
    try {
      // Kilit kalkar (fren DELETE'i en çok 3 sn beklenir), sonra bot 'oto' olur; kilit null olunca diyalog kapanır.
      await this.uyapEngeliniKaldirVeBaslat({kaynak: 'diyalog'});
    } catch (e) {
      console.error('UYAP engeli kaldırılamadı.', e);
    } finally {
      this.deneniyor = false;
    }
  }
}
